// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"44c7a044","707":"3424a9dc","729":"392d5ca4"}[chunkId] + ".js";
};